<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div>
    <v-layout class="pa-0 ma-0  no-gutters" ml-8 >

      <template
          v-if="
                  !(
                    $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
                      .products_count === 1 &&
                    $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
                      .markets_count === 1
                  )
                "
      >
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>

        <v-flex class="pa-0 mb-0 mt-0">
          <v-tooltip left color="success" :disabled="yes_hover_text_f.length===0">
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on">
                 <v-checkbox
                     v-model="yes_selected"
                     :disabled="$store.state.tradeDSM.updatingMainFilters || (entry.min===0 && entry.max===0)"
                     class="ml-15 mt-0 pt-2 mb-0 pb-0 pa-0 pt-3 mr-0 shrink"

                     color="success"
                     @click.stop="onlyBoxClick('yes', yes_selected)"
                 >
                   <template v-slot:label>
                    <span class="text--green text-caption color--success">↑ Up</span>
                  </template>
                 </v-checkbox>
              </span>
            </template>
            <span>{{ yes_hover_text_f }}</span>
          </v-tooltip>
        </v-flex>
        <v-flex class="sm4">
          <v-tooltip top color="success" :disabled="no_hover_text_f.length===0">
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on"
              >
                 <v-checkbox
                     v-model="no_selected"
                     :disabled="$store.state.tradeDSM.updatingMainFilters || (entry.min===1 && entry.max===1)"
                     class="ml-10 mt-0 mb-0 pa-0 shrink pt-3"
                     color="error"
                     @click.stop="onlyBoxClick('no', no_selected)"
                 >
                   <template v-slot:label>
                    <span class="text--green text-caption color--success">↓ Down</span>
                  </template>
                 </v-checkbox>
              </span>

            </template>
            <span>{{ no_hover_text_f }}</span>
          </v-tooltip>
        </v-flex>


        <v-flex class="sm4 ml-0 pt-2">
          <template v-if="!filters_updating_status &&entry.last_selected">
            <v-tooltip
                top
                max-width="200px"
                color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-on="on"
                    @click.stop="apply_filter"
                    x-small
                    class="yellow ml-1"
                >
                  Update
                </v-btn>
              </template>
              <span>Click on [UPDATE] to refresh summary info with your latest filter changes. To extract updated results for current filter changes select [APPLY] at the top of this form.</span>
            </v-tooltip>
          </template>
        </v-flex>
      </template>
      <div v-else>
        <v-tooltip top color="success" v-if="entry.max === 1">
          <template v-slot:activator="{ on, attrs }">

            <span v-on="on" class="green--text ml-8">↑</span>
          </template>
          <span>{{ p1c1_hover_text_f }}</span>
        </v-tooltip>
        <v-tooltip top color="success" v-else>
          <template v-slot:activator="{ on, attrs }">

            <span v-on="on" class="red--text ml-8 text-h5">↓</span>
          </template>
          <span>{{ p1c1_hover_text_f }}</span>
        </v-tooltip>
      </div>
    </v-layout>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import {eventBus} from "@/main";

export default {
  name: 'yes_no_filter_direction',
  props: {
    filter_name: String,
    entry: Object,
    filters_updating_status: Boolean
  },
  mounted() {
    // update the filter value on mount, based on loaded state setting
    // console.log('Filters');
    // console.log(this.filter_name);
    // console.log(this.entry['selected_value']);
    // let a = this.$store.state.tradeDSM.dsm_filter_setttings.Filters[this.filter_name];
    // let start_value = a['entries'][0]['selected_value'];
    let start_value = this.entry['selected_value'];
    if (start_value.length > 0) {
      start_value[0] === 1 ? (this.yes_selected = true) : (this.yes_selected = false); // no must be inverse of yes this.no_selected =
      this.no_selected = !this.yes_selected;
    }
  },
  watch: {
    filters_cleared: function (new_value) {
      if (new_value) {
        this.no_selected = false;
        this.yes_selected = false;
      }
    },
  },
  computed: {
    ...mapGetters(['get_advanved_filters_is_dirty']),
    p1c1_hover_text_f() {
      //
      let product = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code[0]
      let market = this.codeToMarket(this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code[0])
      let extra_text = ''

      if (this.entry.name.indexOf('F1') !== -1 ||
          this.entry.name.indexOf('F3.2.1') !== -1
      ) {
        extra_text = `${market}`
      } else if (this.entry.name.indexOf('F4') !== -1) {
        extra_text = `${product}`
      } else {
        extra_text = `${market} and ${product}`
      }
      if (this.entry.min === 1 && this.entry.max === 1) {
        return `The only outcome for ${extra_text} is Up`
      } else if (this.entry.min === 0 && this.entry.max === 0) {
        return `The only outcome for ${extra_text} is Down`
      } else return ''
    },
    // return `The only outcome for [HS] x [Angola] is Yess: ${this.entry}`
    yes_hover_text_f() {
      if (this.entry.min === 1 && this.entry.max === 1) {
        return "Based on the current selections the only possible outcome is Up"
      } else if (this.entry.min === 0 && this.entry.max === 0) {
        return `Based on the current selections the only possible outcome is Down`
      } else
        return "Click to select, deselect filter 'Up' value"
    },
    no_hover_text_f() {
      if (this.entry.min === 1 && this.entry.max === 1) {
        return `Based on the current selections the only possible outcome is Up`
      } else if (this.entry.min === 0 && this.entry.max === 0) {
        return "Based on the current selections the only possible outcome is Down"
      } else
        return "Click to select, deselect filter 'Down' value"
    },

    filters_cleared() {
      return this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.fresh_start;
    },

    // preset_changed() {
    //   return this.entry.selected_value;
    // },
    entry_changed() {
      return this.entry;
    },
  },

  data: function () {
    return {
      no_selected: false,
      yes_selected: false,
      always_yes: true,
    };
  },
  methods: {
    ...mapMutations([
      'set_advanced_filters_is_dirty',
      'set_filter_box_selection_country',
      'set_filter_box_selection_product',
    ]),
    onlyBoxClick(box_type, event) {
      console.log('clicked')
      if (box_type === 'yes') {
        if (this.yes_selected) {
          console.log(event);
          this.yes_selected = false;
          this.update_state(this.filter_name, this.entry.id, []);
          this.set_advanced_filters_is_dirty(true);
        } else {
          this.yes_selected = true;
          this.no_selected = false;
          this.update_state(this.filter_name, this.entry.id, [1, 1]);
          this.set_advanced_filters_is_dirty(true);
        }
      }
      if (box_type === 'no') {
        if (this.no_selected) {
          this.no_selected = false;
          this.update_state(this.filter_name, this.entry.id, []);
          this.set_advanced_filters_is_dirty(true);
        } else {
          this.no_selected = true;
          this.yes_selected = false;
          this.update_state(this.filter_name, this.entry.id, [0, 0]);
          this.set_advanced_filters_is_dirty(true);
        }
      }
    },
    async apply_filter() {
      await this.update_filters_selection(true)
    },
   async  handleClick(box_type, event) {
      if (box_type === 'yes') {
        if (this.yes_selected) {
          console.log(event);
          this.yes_selected = false;
          this.update_state(this.filter_name, this.entry.id, []);
          this.set_advanced_filters_is_dirty(true);
        } else {
          this.yes_selected = true;
          this.no_selected = false;
          this.update_state(this.filter_name, this.entry.id, [1, 1]);
          this.set_advanced_filters_is_dirty(true);
        }
      }
      if (box_type === 'no') {
        // console.log(event);
        if (this.no_selected) {
          this.no_selected = false;
          this.update_state(this.filter_name, this.entry.id, []);
          this.set_advanced_filters_is_dirty(true);
        } else {
          this.no_selected = true;
          this.yes_selected = false;
          this.update_state(this.filter_name, this.entry.id, [0, 0]);
          this.set_advanced_filters_is_dirty(true);
        }
      }
      await this.update_filters_selection();
    },
    update_state(filter_name, id, value) {
      let value_to_set = {
        filter_name: filter_name,
        id: id,
        value: 0,
        selected_value: value,
      };


      this.$store.commit('setFilter', value_to_set);


      // All the filters ill be moved to here later
      // Initially when a list filter is selected this is set but when you select or change that in the
      // Main filter box, this needs to be overridden as this object is injected last and will override any
      // user changes setting because this is a dropdown the __lte and __gte values is set for the column name
      let col_name = this.$store.state.tradeDSM.dsm_filter_setttings.Filters[filter_name]['entries'][id]['col_name']
      if (value.length===0) {
        // []
        console.log('remove key')
        console.log(col_name)
        delete this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.custom_query[`${col_name}`]
      } else if (value[0] === 1) {
        // [1,1]
        console.log('set true')
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.custom_query[col_name] = true
      } else if (value[0] === 0) {
        // [0, 0]
        console.log('set false')
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.custom_query[col_name] = false
      }
      eventBus.$emit('FILTER_CHANGED')
    },
    reset_values() {
      this.no_selected = false;
      this.yes_selected = false;
    },
  },
};
</script>

<style scoped>
.selector {
  background-color: cyan;
  margin: 0;
}

.compact-form {
  transform: scale(1);
  transform-origin: left;
}

.v-text-field.v-text-field--enclosed .v-text-field__details,
.v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
  margin: 0;
  max-height: 32px;
  min-height: 32px !important;
  display: flex !important;
  align-items: center !important;
}
</style>
